function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 2.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM10.5 5a2 2 0 100-4 2 2 0 000 4zM7 6.5c0-.174.03-.342.085-.498A1.528 1.528 0 007 6H2A1.5 1.5 0 00.5 7.5v.075s0 2.925 4 2.925c1.21 0 2.055-.268 2.644-.642.062-.13.142-.251.238-.358A1.494 1.494 0 017 8.5c0-.384.144-.735.382-1A1.494 1.494 0 017 6.5zM8.5 6a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 2a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 2a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
  fill: "#8F90A6"
});

function SvgAffectedUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAffectedUser;